import { EntityRecord } from '../../utils/CollectionRecord'

const MapRecord = EntityRecord({
  center: null,
  zoom: null,
  link: null,
})

export default MapRecord
